<template>
  <div class="app">
    <vMenu></vMenu>
    <vHeader></vHeader>
    <div class="container"><router-view></router-view></div>
    <vSpin v-if="loading" fullscreen size="large" backgroundColor="rgba(0,0,0,.4)" />
  </div>
</template>

<script>
import { vSpin, vMenu, vHeader } from '@/components';
export default {
  components: {
    vSpin,
    vMenu,
    vHeader,
  },
  computed: {
    loading() {
      return this.$store.state.application.loading;
    },
  },
};
</script>

<style lang="scss">
@import '~@/assets/styles/common/variable';
body {
  width: 100%;
  height: 100%;
}
.app {
  width: 100%;
  min-height: 100vh;
  .v-menu {
    width: 220px;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    background: #363e4f;
    padding-top: 70px;
    z-index: 1;
    overflow-y: scroll;
  }
  .container {
    min-height: 100vh;
    margin-left: 220px;
    padding-top: 110px;
    overflow-x: auto;
    .main {
      width: 90%;
      min-width: 1070px;
      margin: 0 auto;
      padding: 0 20px;
      h1 {
        margin-bottom: 40px;
      }
    }
  }
}
//iview
.ivu-input-wrapper {
  width: 70%;
}
.ivu-card {
  margin-bottom: 40px;
}
.ivu-menu-horizontal {
  margin-bottom: 20px;
}
.ivu-table-wrapper {
  margin-bottom: 20px;
}
.modalBox {
  .ivu-input-wrapper {
    width: 86%;
  }
  .ivu-radio-wrapper,
  .ivu-checkbox-border {
    margin-bottom: 10px;
    white-space: pre-wrap;
  }
}
</style>
